<template>
  <pagefra>
    <div
      class="lift container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <!-- <el-form-item label="所属区域">
              <areaCascader
                ref="ac"
                :multiple="true"
                :checkStrictly="true"
              ></areaCascader>
            </el-form-item> -->
            <el-form-item :label="$l('所属城市')">
              <el-input
                v-model="form.city"
                :placeholder="$l('所属城市')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('所属区域')">
              <el-input
                v-model="form.areaName"
                :placeholder="$l('所属区域')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.domainName"
                :placeholder="$l('地盘名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('电梯工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('电梯工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('注册代码')">
              <el-input
                v-model="form.registerCode"
                :placeholder="$l('注册代码')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('电梯类型')">
              <el-select
                v-model="form.elevatorType"
                :placeholder="$l('电梯类型')"
              >
                <el-option :label="$l('电梯类型')" value></el-option>
                <el-option :label="$l('直梯')" value="直梯"></el-option>
                <el-option :label="$l('扶梯')" value="扶梯"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('地盘类型')">
              <el-select
                v-model="form.domainType"
                :placeholder="$l('地盘类型')"
              >
                <el-option :label="$l('地盘类型')" value></el-option>
                <el-option
                  v-for="item in domainTypeList"
                  :key="item.value"
                  :label="$l(item.text)"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <!-- <el-button type="primary" icon="el-icon-plus" round>新增</el-button> -->
            <el-button
              round
              type="primary"
              icon="el-icon-upload2"
              @click="openImportElevator"
              v-if="hasPermission('批量导入电梯')"
            >
              {{ $l("批量导入电梯") }}
            </el-button>
            <el-button
              round
              icon="el-icon-download"
              @click="exportElevator"
              v-if="hasPermission('导出')"
              >{{ $l("导出") }}
            </el-button>
            <el-button
              round
              type="primary"
              icon="el-icon-download"
              @click="showQRCode(null)"
              v-if="hasPermission('批量生成二维码')"
            >
              {{ $l("批量生成二维码") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            @selection-change="selectChange"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="domainName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('大楼名称')"
              prop="buildingName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('梯号')"
              prop="elevatorNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯工号')"
              prop="jobNum"
              align="center"
              min-width="120"
              sortable
            ></el-table-column>
            <el-table-column
              :label="$l('省份')"
              prop="province"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯类型')"
              prop="elevatorType"
              align="center"
              min-width="120"
              :formatter="elevatorTypeFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('注册代码')"
              prop="registerCode"
              align="center"
              min-width="200"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('保养单位')"
              prop="grtFlg"
              align="center"
              min-width="200"
              :formatter="formatterGrtFlg"
            ></el-table-column> -->
            <el-table-column
              :label="$l('详情')"
              min-width="100"
              show-overflow-tooltip
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('详情')"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-document"
                  class="table-icon"
                  @click="showDetail(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('编辑')"
              min-width="100"
              show-overflow-tooltip
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('编辑')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showEdit(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                >
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('业主二维码')"
              min-width="100"
              show-overflow-tooltip
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('业主二维码')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showQRCode(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-download"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        class="view-dialog"
        :title="$l('电梯档案详情')"
        :visible.sync="viewDialogVisible"
        width="920px"
        @close="currentRow = null"
      >
        <div class="archive-container" v-if="currentRow">
          <!-- 档案头部 -->
          <div class="archive-header">
            <div class="archive-title">
              <span class="archive-title-text"
                >{{ currentRow.domainName }} -
                {{ currentRow.buildingName }}</span
              >
            </div>
            <div class="archive-subtitle">
              <span class="archive-tag">{{ currentRow.elevatorType }}</span>
              <span class="archive-jobnum"
                >电梯工号：{{ currentRow.jobNum }}</span
              >
              <span class="archive-elevnum"
                >梯号：{{ currentRow.elevatorNum }}</span
              >
            </div>
          </div>

          <!-- 档案内容 -->
          <div class="archive-body">
            <!-- 基本信息 -->
            <div class="archive-section">
              <div class="section-title">
                <span class="section-title-line"></span>
                <span class="section-title-text">基本信息</span>
              </div>
              <div class="section-content">
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">{{ $l("注册代码") }}</span>
                    <span class="info-value">{{
                      currentRow.registerCode || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("省份") }}</span>
                    <span class="info-value">{{
                      currentRow.province || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("城市") }}</span>
                    <span class="info-value">{{ currentRow.city || "-" }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("区域") }}</span>
                    <span class="info-value">{{
                      currentRow.areaName || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("地盘名称") }}</span>
                    <span class="info-value">{{
                      currentRow.domainName || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("大楼名称") }}</span>
                    <span class="info-value">{{
                      currentRow.buildingName || "-"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 客户信息 -->
            <div class="archive-section">
              <div class="section-title">
                <span class="section-title-line"></span>
                <span class="section-title-text">客户信息</span>
              </div>
              <div class="section-content">
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">{{ $l("使用客户名称") }}</span>
                    <span class="info-value">{{
                      currentRow.useAccntName || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("所属司名称") }}</span>
                    <span class="info-value">{{
                      currentRow.companyOrg || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("所属站名称") }}</span>
                    <span class="info-value">{{
                      currentRow.stationOrg || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("移交客户时间") }}</span>
                    <span class="info-value">{{
                      currentRow.toAccountTime || "-"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 技术参数 -->
            <div class="archive-section">
              <div class="section-title">
                <span class="section-title-line"></span>
                <span class="section-title-text">技术参数</span>
              </div>
              <div class="section-content">
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">{{ $l("电梯类型") }}</span>
                    <span class="info-value">{{
                      currentRow.elevatorType || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("层") }}</span>
                    <span class="info-value">{{
                      currentRow.floorNum || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("站") }}</span>
                    <span class="info-value">{{
                      currentRow.elevatorStop || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("速度") }}</span>
                    <span class="info-value">{{
                      currentRow.assetspeed
                        ? currentRow.assetspeed + " m/s"
                        : "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("载重") }}</span>
                    <span class="info-value">{{
                      currentRow.assetload ? currentRow.assetload + " kg" : "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("门") }}</span>
                    <span class="info-value">{{
                      currentRow.assetDoor || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("驱动方式") }}</span>
                    <span class="info-value">{{
                      currentRow.driveMode || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("营业梯种") }}</span>
                    <span class="info-value">{{
                      currentRow.productPart || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("梯龄") }}</span>
                    <span class="info-value">{{
                      currentRow.elevatorAge || "-"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 维保信息 -->
            <div class="archive-section">
              <div class="section-title">
                <span class="section-title-line"></span>
                <span class="section-title-text">维保信息</span>
              </div>
              <div class="section-content">
                <div class="info-grid">
                  <!-- <div class="info-item">
                    <span class="info-label">{{ $l('保养单位') }}</span>
                    <span class="info-value" :class="currentRow.grtFlg === 'Y' ? 'value-highlight' : ''">{{ currentRow.grtFlg === 'Y' ? '日立电梯' : '非日立保养' }}</span>
                  </div> -->
                  <div class="info-item">
                    <span class="info-label">{{ $l("下次年检日期") }}</span>
                    <span class="info-value">{{
                      currentRow.inspectDate
                        ? currentRow.inspectDate.split(" ")[0]
                        : "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("移交维保时间") }}</span>
                    <span class="info-value">{{
                      currentRow.tomaintaintime || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("技检发证日期") }}</span>
                    <span class="info-value">{{
                      currentRow.techCertTime || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("上报完工期") }}</span>
                    <span class="info-value">{{
                      currentRow.rtpFinishTime || "-"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 运行监控 -->
            <div class="archive-section">
              <div class="section-title">
                <span class="section-title-line"></span>
                <span class="section-title-text">运行监控</span>
              </div>
              <div class="section-content">
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">{{ $l("运行次数") }}</span>
                    <span class="info-value monitor-value">{{
                      currentRow.runTimesOr || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("运行时间") }}</span>
                    <span class="info-value monitor-value">{{
                      currentRow.totalTimeOr || "-"
                    }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("钢丝绳弯折次数") }}</span>
                    <span class="info-value monitor-value">{{
                      currentRow.bendTimesOr || "-"
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 位置信息 -->
            <div class="archive-section">
              <div class="section-title">
                <span class="section-title-line"></span>
                <span class="section-title-text">位置信息</span>
              </div>
              <div class="section-content">
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">{{ $l("经度") }}</span>
                    <span class="info-value">{{ currentRow.x || "-" }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("纬度") }}</span>
                    <span class="info-value">{{ currentRow.y || "-" }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ $l("地图") }}</span>
                    <span class="info-value">
                      <svgicon
                        name="map2"
                        class="location-icon"
                        @click="openLocation"
                      ></svgicon>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 备注 -->
            <div class="archive-section">
              <div class="section-title">
                <span class="section-title-line"></span>
                <span class="section-title-text">备注</span>
              </div>
              <div class="section-content">
                <div class="remark-content">{{ currentRow.remark || "-" }}</div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="viewDialogVisible = false"
            >{{ $l("关闭") }}
          </el-button>
        </div>
      </el-dialog>

      <el-dialog
        :title="$l('编辑电梯信息')"
        :visible.sync="editDialogVisible"
        width="680px"
      >
        <el-form
          ref="editForm"
          :model="editForm"
          :rules="rules"
          label-width="140px"
          size="medium"
          class="dialog-form"
        >
          <el-form-item :label="$l('所属区域')" prop="areaName">
            <el-input v-model="editForm.areaName"></el-input>
          </el-form-item>
          <el-form-item :label="$l('电梯工号')">
            <el-input v-model="editForm.jobNum" :disabled="true"></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$l('地盘名称')" prop="domainName">
            <el-input v-model="editForm.domainName"></el-input>
          </el-form-item>
          <el-form-item :label="$l('大楼名称')" prop="buildingName">
            <el-input v-model="editForm.buildingName"></el-input>
          </el-form-item>
          <el-form-item :label="$l('梯号')" prop="elevatorNum">
            <el-input v-model="editForm.elevatorNum"></el-input>
          </el-form-item>
          <el-form-item :label="$l('地盘类型')" prop="domainType">
            <el-input v-model="editForm.domainType"></el-input>
          </el-form-item>
          <el-form-item :label="$l('注册代码')" prop="registerCode">
            <el-input v-model="editForm.registerCode"></el-input>
          </el-form-item> -->
          <el-form-item :label="$l('备注说明')" prop="remark">
            <el-input
              type="textarea"
              v-model="editForm.remark"
              rows="4"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="editDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="submit"
            >{{ $l("确定") }}
          </el-button>
        </div>
      </el-dialog>

      <el-dialog
        :title="$l('批量导入电梯')"
        :visible.sync="importElevatorDialogVisible"
        width="30%"
      >
        <el-upload
          ref="upload"
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :limit="2"
          :file-list="fileList"
          :on-change="onFileChange"
          :on-remove="onFileRemove"
          list-type="text"
          :auto-upload="false"
        >
          <el-button size="small" round type="primary"
            >{{ $l("点击上传") }}
          </el-button>
          <div slot="tip" class="el-upload__tip">
            {{ $l("只能上传xlsx文件") }}

            <a
              href="#"
              style="text-decoration: none"
              @click="downloadTemplate('电梯基础信息更新模板.xlsx')"
              >{{ $l("模板文件") }}
            </a>
          </div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importElevatorDialogVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="importElevator"
            >{{ $l("确 定") }}
          </el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="$l('下载业主二维码')"
        :visible.sync="qrcodeDialogVisible"
        width="400px"
        height="300px"
        class="qrcode"
      >
        <!-- <div style="text-align: center">
          <el-image :src="qrcodeImg"></el-image>
        </div> -->
        <el-form size="medium">
          <el-form-item :label="$l('有效期时间')">
            <el-date-picker
              v-model="expireTime"
              type="date"
              :placeholder="$l('选择时间')"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$l('版本选择')">
            <el-select v-model="form.versionType" :placeholder="$l('版本选择')">
              <el-option
                v-for="item in versionList"
                :label="$l(item.label)"
                :value="item.value"
                :key="item.value"
              ></el-option> </el-select
            >&nbsp;
            <el-tooltip placement="right">
              <div slot="content">
                <p>
                  版本1，页面功能点如下：<br />
                  1）电梯运行监视动画；<br />
                  2）电梯与人员定位；<br />
                  3）安全乘梯公益动画（有视频号链接）。
                </p>
                <p>
                  版本2，页面功能点如下：<br />
                  1）电梯运行监视动画；<br />
                  2）电梯与人员定位；<br />
                  3）上次和下次保养记录；<br />
                  4）救援服务进度；<br />
                  5）安全乘梯公益动画（有视频号链接）。
                </p>
                <p>
                  版本3，页面功能点如下：<br />
                  1）电梯运行监视动画；<br />
                  2）电梯与人员定位；<br />
                  3）上次和下次保养记录，可查看保养图片和下载PDF；<br />
                  4）救援服务进度；<br />
                  5）安全乘梯公益动画（有视频号链接）。
                </p>
              </div>
              <span style="color: red; cursor: pointer">tips</span>
            </el-tooltip>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="qrcodeDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="downloadQRCode()"
            >{{ $l("下载") }}
          </el-button>
        </div>
      </el-dialog>

      <personLocation
        ref="personLocation"
        :showButton="false"
        :showTrace="false"
        label="电梯定位"
      ></personLocation>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import personLocation from "@/components/personLocation.vue";
// import areaCascader from "@/components/areaCascader.vue";
import global from "@/mixins/global.js";
export default {
  name: "lift",
  mixins: [global],
  components: {
    panel,
    breadcrumb,
    personLocation,
    // areaCascader,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    // var validateBuildingName = (rule, value, callback) => {
    //   if (!value || value.trim() == "") {
    //     callback(new Error("请输入大楼名称"));
    //   } else {
    //     callback();
    //   }
    // };
    // var validateElevatorNum = (rule, value, callback) => {
    //   if (!value || value.trim() == "") {
    //     callback(new Error("请输入梯号"));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      date: "",
      form: {
        city: "",
        areaName: "",
        domainName: "",
        jobNum: "",
        registerCode: "",
        elevatorType: "",
        domainType: "",
        versionType: "1",
        dataPermissionList: [],
      },
      tableData: [],
      editForm: {
        elevatorId: "",
        jobNum: "",
        domainId: "",
        domainName: "",
        buildingName: "",
        elevatorNum: "",
        areaName: "",
        province: "",
        city: "",
        address: "",
        domainType: "",
        registerCode: "",
        allowed: false,
        remark: "",
      },
      rules: {
        areaName: [
          {
            max: 100,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        domainName: [
          {
            max: 100,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
        ],
        buildingName: [
          // { validator: validateBuildingName, trigger: "blur" },
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        elevatorNum: [
          // { validator: validateElevatorNum, trigger: "blur" },
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        registerCode: [
          // { validator: validateElevatorNum, trigger: "blur" },
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        remark: [
          // { validator: validateElevatorNum, trigger: "blur" },
          {
            max: 50,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
        ],
      },
      viewDialogVisible: false,
      editDialogVisible: false,
      domainTypeList: [],
      loading: false,
      fileList: [],
      file: null,
      fullLoading: false,
      importElevatorDialogVisible: false,
      qrcodeDialogVisible: false,
      qrcodeImg: null,
      expireTime: new Date(),
      currentRow: null,
      pickerOptions: {
        disabledDate: (time) => {
          const yesterdayTime = new Date(
            this.$common.getBeforeDate(1) + " 23:59:59"
          ).getTime();
          if (time) {
            return time.getTime() <= yesterdayTime;
          }
        },
      },
      selectedList: [], //选中的行集合
      versionList: [
        {
          label: "版本1",
          value: "1",
        },
        {
          label: "版本2",
          value: "2",
        },
        {
          label: "版本3",
          value: "3",
        },
      ],
    };
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      // this.form.dataPermissionList = this.$refs.ac.getSelectedList();
      this.form.pageName = "lift";
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(this.$apiConfig.search_elevator_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    loadDomainTypeData() {
      this.$http
        .get(this.$apiConfig.get_domain_type_url)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            result.data.forEach((item, index) => {
              this.domainTypeList.push({
                text: item,
                value: item,
              });
            });
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    showDetail(row) {
      this.viewDialogVisible = true;
      this.currentRow = row;
    },
    openLocation() {
      this.$refs.personLocation.open(this.currentRow);
    },
    showEdit(row) {
      this.editDialogVisible = true;
      for (const key in this.editForm) {
        this.editForm[key] = row[key];
      }
    },
    submit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$http
            .post(this.$apiConfig.save_elevator_url, this.editForm)
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.editDialogVisible = false;
                this.search();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    openImportElevator() {
      this.fileList = [];
      this.file = null;
      this.importElevatorDialogVisible = true;
    },
    onFileChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }
      this.file = file.raw;
    },
    onFileRemove() {
      this.file = null;
    },
    importElevator() {
      if (this.file == null) {
        this.message(1, "请选择要上传的文件");
        return;
      }
      if (!this.file.name.endsWith(".xlsx")) {
        this.message(1, "文件类型错误，请选择类型为xlsx的文件");
        return;
      }
      this.fullLoading = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.$http
        .post(this.$apiConfig.import_elevator_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.fullLoading = false;
          let result = response.data;
          let data = result.data;
          if (result.code == 0) {
            this.message(result.code, result.msg);
            this.importElevatorDialogVisible = false;
            this.initData();
          } else if (data) {
            let html =
              '<div style="height:400px;word-wrap: break-word;overflow:auto;">';
            if (data.notJobNumList.length > 0) {
              html +=
                '<span style="color:blue">不存在的电梯工号：</span><br/>' +
                data.notJobNumList.join(",") +
                "<br/>";
            }
            if (data.notAreaJobNumList.length > 0) {
              html +=
                '<span style="color:blue">不在区域内的电梯工号：</span><br/>' +
                data.notAreaJobNumList.join(",") +
                "<br/>";
            }
            if (data.addFailureJobNumList.length > 0) {
              html +=
                '<span style="color:blue">导入失败的电梯工号：</span><br/>' +
                data.addFailureJobNumList.join(",");
            }
            html += "</div>";
            this.$alert(html, "提示", {
              dangerouslyUseHTMLString: true,
            });
            this.initData();
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    exportElevator() {
      this.fullLoading = true;
      let filename =
        "电梯信息维护表_" + this.$common.formatCurrentDateTime(false) + ".xlsx";
      this.$http({
        url: this.$apiConfig.export_elevator_url,
        method: "post",
        responseType: "blob",
        data: this.form,
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大"
            );
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    inspectDateFormatter(row) {
      if (row.inspectDate) {
        return row.inspectDate.split(" ")[0];
      }
      return row.inspectDate;
    },
    elevatorTypeFormatter(row) {
      return this.$l(row.elevatorType);
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    showQRCode(row) {
      if (row) {
        this.currentRow = row;
      } else {
        this.currentRow = null;
        if (this.selectedList.length <= 0) {
          this.message(1, "请选择数据");
          return;
        }
      }
      this.qrcodeDialogVisible = true;
      let date1 = new Date();
      let date2 = new Date(date1);
      date2.setDate(date1.getDate() + 29);
      this.expireTime = date2;
    },
    downloadQRCode() {
      if (!this.expireTime) {
        this.message(1, "请选择有效期时间");
        return;
      }
      this.fullLoading = true;
      const expireTime = this.$common.formatDate(this.expireTime);
      let fileName = "result.zip";
      let jobNumList = this.selectedList.map((t) => t.jobNum);
      if (this.currentRow) {
        jobNumList = [this.currentRow.jobNum];
        fileName = jobNumList[0] + "_" + this.form.versionType + ".jpg";
      } else if (this.selectedList.length == 1) {
        fileName = jobNumList[0] + "_" + this.form.versionType + ".jpg";
      }
      this.$http({
        url: this.$apiConfig.get_qrcode_url,
        method: "post",
        data: {
          // elevatorId: this.currentRow.elevatorId,
          jobNumList: jobNumList,
          expireTime: expireTime,
          versionType: this.form.versionType,
        },
        responseType: "blob",
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "电梯工号不存在"
                : status == 202
                ? "有效期时间不能小于或等于当前时间"
                : "二维码下载失败"
            );
            return;
          }

          this.message(
            0,
            `二维码有效时间为${this.$common.getDistanceDays(
              this.$common.formatDate() + " 00:00:00",
              expireTime + " 23:59:59"
            )}天`
          );
          this.qrcodeDialogVisible = false;
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = fileName;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
      // this.fullLoading = true;
      // this.$http
      //   .get(this.$apiConfig.get_qrcode_url, {
      //     params: {
      //       jobNum: row.jobNum,
      //       width: 280,
      //       height: 280,
      //     },
      //   })
      //   .then((response) => {
      //     this.fullLoading = false;
      //     this.qrcodeDialogVisible = true;
      //     let result = response.data;
      //     if (result.code == 0) {
      //       this.qrcodeImg = result.data;
      //     } else {
      //       this.message(result.code, result.msg);
      //     }
      //   })
      //   .catch((error) => {
      //     this.fullLoading = false;
      //     this.errorMessage(0);
      //     this.$sentry.captureException(error);
      //   });
    },
    downloadTemplate(fileName) {
      this.$http({
        url: this.$apiConfig.download_template_url + "?fileName=" + fileName,
        method: "get",
        responseType: "blob",
      })
        .then((response) => {
          const status = response.status;
          if (status != 200) {
            this.message(1, "下载失败");
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = fileName;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    formatterGrtFlg(row) {
      if (row.grtFlg === "Y") {
        return "日立电梯";
      } else {
        return "非日立保养";
      }
    },
  },
  mounted() {
    if (this.loaded) {
      this.loadDomainTypeData();
      this.initData();
    }
  },
};
</script>
<style lang="scss" scoped>
.lift {
  .el-radio-group {
  }

  /deep/ .el-radio-button__inner {
    padding: 0px 15px;
    margin: 9px 0;
    border-top: 0;
    border-bottom: 0;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border-color: $--border-color-base;
    box-shadow: none;
    background-color: transparent;
    color: $--color-primary;
  }
  /deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-left: 0;
  }
  /deep/ .el-radio-button:last-child .el-radio-button__inner {
    border-right: 0;
  }
  .dialog-form {
    .el-input,
    .el-select,
    .el-textarea {
      width: 400px;
    }
  }
  .qrcode {
    /deep/ .el-dialog__body {
      padding: 30px 20px 0px 20px;
    }
  }
  .location-icon {
    width: 20px;
    height: 20px;
    color: $--color-primary;
    cursor: pointer;
    vertical-align: middle;
    transition: 0.2s;
    &:hover {
      transform: scale(1.15);
    }
  }
  .view-dialog {
    /deep/ .el-dialog__body {
      padding: 0;
      background: #f5f7fa;
    }
    .archive-container {
      .archive-header {
        background: linear-gradient(135deg, #e02424 0%, #f05656 100%);
        padding: 24px 30px;
        color: #fff;
        .archive-title {
          .archive-title-text {
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 1px;
          }
        }
        .archive-subtitle {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-top: 12px;
          .archive-tag {
            background: rgba(255, 255, 255, 0.3);
            padding: 4px 14px;
            border-radius: 4px;
            font-size: 13px;
          }
          .archive-jobnum,
          .archive-elevnum {
            font-size: 13px;
            opacity: 0.9;
          }
        }
      }
      .archive-body {
        padding: 20px 30px 24px;
        .archive-section {
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
          .section-title {
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            padding-bottom: 0;
            .section-title-line {
              display: inline-block;
              width: 4px;
              height: 16px;
              background: #e02424;
              border-radius: 2px;
              margin-right: 10px;
            }
            .section-title-text {
              font-size: 15px;
              font-weight: 600;
              color: #303133;
            }
          }
          .section-content {
            background: #fff;
            border-radius: 6px;
            padding: 16px 20px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
            .info-grid {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 14px 24px;
              .info-item {
                display: flex;
                align-items: baseline;
                gap: 8px;
                .info-label {
                  flex-shrink: 0;
                  font-size: 13px;
                  color: #909399;
                  min-width: 90px;
                }
                .info-value {
                  font-size: 14px;
                  color: #303133;
                  word-break: break-all;
                }
                .value-highlight {
                  color: #e02424;
                  font-weight: 600;
                }
              }
              .monitor-value {
                color: #e6a23c;
                font-weight: 600;
              }
            }
          }
          .remark-content {
            font-size: 14px;
            color: #303133;
            line-height: 1.8;
            word-break: break-all;
          }
        }
      }
    }
    /deep/ .el-dialog__footer {
      padding: 12px 30px;
      background: #fff;
      border-top: 1px solid #ebeef5;
    }
  }
}
</style>
